export class Mutations {
    public static readonly SetAllApprovals: string = 'setAllApprovals';
    public static readonly SetAllApprovalsPage: string = 'setAllApprovalsPage';
    public static readonly SetAllApprovalsPageSize: string = 'setAllApprovalsPageSize';
    public static readonly SetAllApprovalsTotalPages: string = 'setAllApprovalsTotalPages';
    public static readonly SetAllApprovalsTotalApprovals: string = 'setAllApprovalsTotal';
    public static readonly SetAllApprovalsFilterStatus: string = 'setAllApprovalsFilterStatus';
    public static readonly SetAllApprovalsFrom: string = 'setAllApprovalsFrom';
    public static readonly SetAllApprovalsTo: string = 'setAllApprovalsTo';
}
